import { render, staticRenderFns } from "./MaxCollectsCard.vue?vue&type=template&id=9017ab72&scoped=true"
import script from "./MaxCollectsCard.vue?vue&type=script&lang=ts"
export * from "./MaxCollectsCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxCollectsCard.vue?vue&type=style&index=0&id=9017ab72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9017ab72",
  null
  
)

export default component.exports